import voucherTransformer from '../../transformers/voucher';
import tableUtil from '../../utils/table';
import axios from 'axios';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    let params = query || {};
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'vouchers', { params })
      .then(({ data }) => {
        let dataRes = {};
        if (data.data) {
          dataRes.data = voucherTransformer.fetchCollection(data.data);
        }
        dataRes.meta = data.pagination ? { pagination: data.pagination } : tableUtil.mockupMeta(dataRes.data.length);
        resolve(dataRes);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
